/** Same fallback /register uses when public register options cannot be loaded. */
export const FALLBACK_REGISTER_OPTIONS = {
  default_country_code: 'SK',
  default_phone_country_code: '+421',
  default_locale: 'sk',
  default_timezone: 'Europe/Bratislava',
  default_billing_currency: 'EUR',
  countries: [{ code: 'SK', name: 'Slovensko', phone_code: '+421' }],
  phone_country_codes: ['+421', '+420', '+43', '+49', '+48', '+36', '+44', '+1'],
};

export function findCountryByCode(countries, code) {
  if (!code) {
    return null;
  }
  return (countries || []).find((country) => country.code === code) || null;
}

export function isValidNationalPhoneInput(value) {
  if (!value || !String(value).trim()) {
    return true;
  }
  return /^[\d\s()-]+$/.test(String(value));
}

export function emptyRegisterCustomerForm(options = FALLBACK_REGISTER_OPTIONS) {
  const country = findCountryByCode(options.countries, options.default_country_code);
  return {
    customer_type: '',
    company_name: '',
    contact_name: '',
    contact_email: '',
    country_code: options.default_country_code,
    country_name: country?.name || '',
    phone_country_code: options.default_phone_country_code,
    phone_national_number: '',
    locale: options.default_locale,
    timezone: options.default_timezone,
    billing_currency: options.default_billing_currency,
    company_id_number: '',
    tax_id: '',
    vat_id: '',
    address_line1: '',
    city: '',
    postal_code: '',
    notes: '',
  };
}
